import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../../api/quarkusApi';

export function useUserAccesses() {
  const navigate = useNavigate();

  const [userAccesses, setUserAccesses] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchUserAccesses = useCallback(
    (startDate, endDate) => {
      setLoading(true);
      quarkusApi
        .get('/admin/user-access', {
          headers: { Authorization: sessionStorage.getItem('token') },
          params: {
            startDate: startDate.format('YYYY-MM-DD'),
            endDate: endDate.format('YYYY-MM-DD'),
          },
        })
        .then((returnFromApi) => setUserAccesses(returnFromApi.data))
        .catch((returnFromApi) => {
          setError(returnFromApi.response?.data);
          console.error('ops! ocorreu um erro' + returnFromApi);
          if (returnFromApi.response?.status === 401) {
            navigate('/expired-session');
          }
        })
        .finally(() => setLoading(false));
    },
    [navigate],
  );

  return { userAccesses, isLoading, error, fetchUserAccesses };
}
